/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(APIFactory, ContentActionsProviderAPI) {

	class LassoSelectAction {
		constructor({ features }) {
			if(features) {
				this.features = features;
				this.dashboard = features.API;
				this.lasso = features.Lasso;
				features.ContentActions.registerProvider('lasso', this.getAPI());
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.dashboard = null;
		}

		getContentActionList(idList) {
			if (this._supportAction(idList) && this.content) {
				const visualizationGesture = this.content.getFeature('VisualizationGesture');

				return this.lasso.getContributions().map(contribution => ({
					id: contribution.id,
					name: contribution.name,
					label: contribution.label,
					icon: this.features['Icons'].getIcon(contribution.icon) && this.features['Icons'].getIcon(contribution.icon).id,
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_DATA,
					order: 50,
					selected: visualizationGesture ? visualizationGesture.getLassoSelectState() && visualizationGesture.getLassoViewId() === contribution.id : false,
					actions: {
						apply: this.lasso.toggleLassoSelect.bind(this.lasso, contribution.id)
					}
				}));
			}
			return [];
		}

		_supportAction(idList) {
			if (!this._isInteractionEnabled('lassoSelect')) {
				return false;
			}
			if (idList.length !== 1) {
				return false;
			}
			if (this.dashboard.getMode() === this.dashboard.MODES.EDIT_GROUP) {
				return false;
			}

			this.content = this.dashboard.getCanvas().getContent(idList[0]);
			if (!this.content) {
				return false;
			}

			const visualization = this.content.getFeature('Visualization');
			if (!visualization || visualization.getDefinition().getState().getError() ||
			!visualization.getSlots().isMappingComplete()) {
				return false;
			}

			const state = this.content.getFeature('state');
			const hasError = Boolean(state && !!state.getError());
			if (hasError) {
				return false;
			}

			return this.content.getType() === 'widget.live'
				&& this._isSupportedVisualizationType(visualization.getType())
				&& !visualization.getDefinition().getProperty('isSchematic')
				&& !visualization.getDefinition().getProperty('isCustomVis');
		}

		_isSupportedVisualizationType(type) {
			const visDefsNoLassoSelect = [
				'Singleton',
				'DataPlayer',
				'Crosstab',
				'List',
				'Hierarchy',
				'KPI',
				'Pie',
				'Wordle',
				'Area',
				'Dial',
				'Bullet',
				'DecisionTree',
				'Sunburst',
				'Spiral',
				'DriverAnalysis',
				'visualizationPreview',
				'snippetList'
			];

			return !visDefsNoLassoSelect.includes(type);
		}

		/**
		 * Check whether a particular interaction is enabled.
		 * Perspective drives this config.
		 *
		 * @param {string} name - interaction name
		 *
		 * @return {boolean} TRUE if interaction is enabled and FALSE if not
		 */
		_isInteractionEnabled(name) {
			const config = this._getInteractionConfig();
			if (config.hasOwnProperty(name) && [false, 'false'].indexOf(config[name]) !== -1) {
				return false;
			}
			return true;
		}

		_getInteractionConfig() {
			return this.dashboard.getAppConfig('interactions') || {};
		}
	}
	return LassoSelectAction;
});
